import {BusEvent, Dispatcher, DispatcherPriority, EventBus} from 'dispatcher'
import {Command} from './WSCMD'
import {
  CHAT_ERROR_TYPE,
  DIRECT_MESSAGE_TYPE,
  WS_CHAT_TYPE_VALUE,
  WS_DIRECT_MESSAGE_ERROR_DATA,
  WS_DIRECT_MESSAGE_SEND_DATA
} from 'ws'

export class SendMessageCommand extends Command<
  WS_DIRECT_MESSAGE_SEND_DATA,
  unknown
> {
  protected uuid = ''
  protected cmd = ''
  protected meta = undefined
  protected data = {}
  protected dispatcher: Dispatcher<WS_DIRECT_MESSAGE_SEND_DATA, unknown> =
    new (class extends Dispatcher<WS_DIRECT_MESSAGE_SEND_DATA, unknown> {
      constructor(
        private uuid: string,
        eventBus: EventBus
      ) {
        super(eventBus)
      }

      protected consumable: boolean = true

      protected criteria(
        event: BusEvent<WS_DIRECT_MESSAGE_SEND_DATA, unknown>
      ): boolean {
        return (
          event.type === WS_CHAT_TYPE_VALUE &&
          (event.data?.type === DIRECT_MESSAGE_TYPE ||
            event.data?.type === CHAT_ERROR_TYPE) &&
          event.data?.data._id === this.uuid
        )
      }

      protected priority: DispatcherPriority = 'COMMAND'
    })(this.event.data._id, this.eventBus)

  constructor(
    private event: WS_DIRECT_MESSAGE_SEND_DATA,
    protected eventBus: EventBus
  ) {
    super(eventBus)
  }

  execute(): Promise<BusEvent<WS_DIRECT_MESSAGE_SEND_DATA, unknown>> {
    return new Promise((resolve, reject) => {
      this.registry = this.dispatcher.register((event) => {
        if (
          (event as unknown as BusEvent<WS_DIRECT_MESSAGE_ERROR_DATA, unknown>)
            .data!.type === CHAT_ERROR_TYPE
        ) {
          reject(new Error('Unable to send message'))
        } else {
          resolve(event)
        }
        this.registry?.unregister()
      })
      this.eventBus.fire({type: WS_CHAT_TYPE_VALUE, data: this.event})
    })
  }
}
